export default function EATTransformativeSeeds({ children }) {
  return (
    <>
      <p>
        Attendees will also have the opportunity to meet several designers and explore their work in
        person, including Yongxin Lai with the Popped Grain Archive, tofoodesign with We Wheat
        Weave, Domingo Club with Edible Echoes and Living Necklace: A Cycle of Growth, Fang Hu and
        Shijia Huang with Bubbling Bricks: A Crafting Exploration, Niki Dimova with Faba-Forma, and
        Koh Zhi Hong Benjamin with Zero Waste System: Expandable Porous Material.
      </p>
      <p>
        From 6:30 pm to 7:30 pm, join the participative live show Faba Forma by Niki Dimova. Guests
        can experiment with Faba-Forma, a biodegradable material made from bean waste, using manual
        extruding guns to craft unique designs in various colors and shapes.
      </p>
      <p>
        At 8:00 pm, Atelier Fang will present Bubbling Bricks, an experimental live show
        demonstrating the creation of bio-based bobbling bricks from edible materials. Visitors are
        welcome to join or leave at any time during this interactive demonstration.
      </p>
      <p>
        Conclude your evening with a Tempeh Tasting hosted by Domingo Club from 9:30 pm to 10:30 pm.
        Sample tempeh produced from a 2-day fermentation process, linked to their community
        performance involving the Living Necklace: A Cycle of Growth. While visitors can participate
        at any time, please note that only 20 portions of tempeh will be available for tasting.
      </p>
      <p>
        Don't miss this opportunity to immerse yourself in innovative design and delicious
        experimentation!
      </p>
      {children}
    </>
  );
}
